const SERVER_DATA = typeof window !== 'undefined' ? window.SERVER_DATA || {} : {}

const { sentryDSN, sentryDisabled, sentryRelease, targetEnv } = SERVER_DATA

const effectiveDSN = sentryDisabled ? undefined : sentryDSN

const sentryDefaults = {
  dsn: effectiveDSN,
  environment: targetEnv,
  release: sentryRelease,
  ignoreErrors: [
    // Random plugins/extensions
    'top.GLOBALS',
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    'originalCreateNotification',
    'canvas.contentDocument',
    'MyApp_RemoveAllHighlights',
    // Working as designed.  See https://fhjira.churchofjesuschrist.org/browse/FSS-8401
    'TimeoutError: Transaction timed out due to inactivity.',
    // Facebook borked
    'fb_xd_fragment',
    // Firefox throws this error in private browsing when using localStorage, nothing we can do right now
    'SecurityError: The operation is insecure.',
    // possible Firefox profile corruption? see https://fhjira.churchofjesuschrist.org/browse/FSS-6972
    `can't redefine non-configurable property "userAgent"`,
    // Not sure what to do with this one https://github.com/mozilla-mobile/firefox-ios/issues/5818
    `undefined is not an object (evaluating 'window.webkit.messageHandlers')`,
    // reported to Adobe, nothing we can do
    'Failed to load script https://assets.adobedtm.com/extensions/',
    // temporary ignore until https://fhjira.churchofjesuschrist.org/browse/SITE-3038 and
    // https://fhjira.churchofjesuschrist.org/browse/SITE-3039 are fixed
    /getComputedStyle.*1 is not/,
    'Argument 1 of Window.getComputedStyle is not an object.',
    // Nothing we can do, has been reported to Kurt to work with trustArc on this
    'EU compliance was not acknowledged by the user.',
    // reported to AppDynamics, will be fixed in next release
    `Cannot read property 'api' of undefined`,
    // temporary ignore until fixed https://fhjira.churchofjesuschrist.org/browse/FRONTIER-499
    'Error: Request failed with status code 453',
    // temporary ignore until we figure out what to do
    'No available storage method found',
    // Caused by add-ons in Firefox; nothing we can do. See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Dead_object
    `can't access dead object`,
    // A benign error caused by Ghosting: https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
    'ResizeObserver loop limit exceeded',
    // Another benign error: https://stackoverflow.com/questions/64238740/how-to-ignore-the-resizeobserver-loop-limit-exceeded-in-testcafe
    'ResizeObserver loop completed with undelivered notifications.',
    // Ignoring this error that is chewing through all of our error events in sentry
    'cidVal.toLowerCase is not a function',
    // Quota-killer, seems to be google docs embed or extension? https://github.com/mozilla/fxa-content-server/issues/4138
    /docs-homescreen-gb-container/,
    // Ignoring Google translate issues: Blocked attempt to use history.pushState() to change session history URL from https://www-familysearch-org.translate.goog/...
    /Blocked attempt.*https:\/\/www-familysearch-org.translate.goog\//,
    // Ignoring Safari error caused by LastPass extension
    'Non-Error promise rejection captured with value: Not implemented on this platform',
    // This is most likely happening due to the safe links being scanned by Outlook: https://stackoverflow.com/questions/75536442/troubleshooting-non-error-promise-rejection-captured-with-value-object-not-fou
    'Non-Error promise rejection captured with value: Object Not Found Matching Id:5, MethodName:update, ParamCount:4',
    // Temporary ignore until we can fix this error permanently
    /getFeatureFlag shared_addLangArabic before a connection/,
    // Unnecessary analytics from Bitmovin player. See https://familysearch.slack.com/archives/C082SG7NV2L/p1740074832991859
    /.*Youbora.*failed.*/,
    // Ignoring extremely verbose bitmovin errors
    `undefined is not an object (evaluating 'window.bitmovin`,
    `Cannot read properties of undefined (reading 'bitmovin-player-`,
    // Ignoring this error as it generates a high volume of events in Sentry and does not require immediate action
    'NoUserSessionError: No User Session Id',
  ],
  denyUrls: [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,
    // Browser extensions
    /\w+-extension:\/\//i,
  ],
}

function mergeSentryConfig(overrides = {}) {
  if (overrides.ignoreErrors) {
    overrides.ignoreErrors = sentryDefaults.ignoreErrors.concat(overrides.ignoreErrors)
  }
  if (overrides.denyUrls) {
    overrides.denyUrls = sentryDefaults.denyUrls.concat(overrides.denyUrls)
  }
  return { ...sentryDefaults, ...overrides }
}

export { mergeSentryConfig, sentryDefaults, effectiveDSN as sentryDSN, sentryDisabled, sentryRelease }
